import React from 'react'

import Icon from '~/components/icon'
import { i18n } from '~/i18n'

import {
  SubStepContent,
  SubStepAction,
  StepNumber,
  SubStepHeading,
  SubStepWrapper,
} from './styles'

import type { SubStepState } from './types'
import type { ReactNode } from 'react'

export type Props = {
  children?: ReactNode
  className?: string
  number: number
  onClick?: () => void
  showEditButtonAsArrow?: boolean
  showStepNumber?: boolean
  state: SubStepState
  title: string
  adjacentActionButton?: boolean
}

const SubStep = ({
  children,
  className,
  number,
  onClick,
  showEditButtonAsArrow,
  showStepNumber = true,
  state,
  title,
  adjacentActionButton = false,
}: Props) => {
  return (
    <SubStepWrapper
      className={className}
      data-testid={`substep-${state}`}
      $state={state}
      $showStepNumber={showStepNumber}
      $adjacentActionButton={adjacentActionButton}
    >
      {showStepNumber && <StepNumber solid>{number}</StepNumber>}
      <SubStepHeading title={title} titleVariant="normal" />
      {onClick && (
        <SubStepAction
          className="substep-edit"
          title={i18n.t('components.substep.edit_btn')}
          onClick={onClick}
        >
          {showEditButtonAsArrow ? (
            <Icon glyph="chevron-down" className="amp-card-icon" />
          ) : (
            i18n.t('components.substep.edit_btn')
          )}
        </SubStepAction>
      )}

      <SubStepContent>{children}</SubStepContent>
    </SubStepWrapper>
  )
}

export default SubStep
